import type { NextPage } from 'next';
import React from 'react';

export const Index: NextPage = () => <div>Lendware</div>;

export default Index;
